interface ChatSendMessage {
    message: string;
    chatId: string;
  }
  
  interface ChatMessageDto {
    senderId: number;
    message: string;
    createdAt: string;
  }
  
  interface ChatMessageDomain {
    senderId: number;
    message: string;
    createdAt: Date;
  }
  
  const mapChatMessageDtoToDomain = (chatMessageDto: ChatMessageDto): ChatMessageDomain => {
    return {
      senderId: chatMessageDto.senderId,
      message: chatMessageDto.message,
      createdAt: new Date(chatMessageDto.createdAt),
    };
  };
  
  
  interface CanUserSendMessage {
    canUserSendMessage: boolean;
  }
  interface UnresolvedCount {
    unresolvedCount: number;
  }
  
  interface ChatId {
    chatId: string;
  }
  
  export type { ChatSendMessage, ChatMessageDto, ChatMessageDomain, CanUserSendMessage, UnresolvedCount, ChatId };
  export { mapChatMessageDtoToDomain };